export const companiesData = [
 { 
        name: "ДИ ТИ ЕС ГРУП ООД", 
        activity: "Търговия на дребно", 
        vat: "Регистрация по ЗДДС",
        period: "2023 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=201632656"
    },
    { 
        name: "НОВА ГРУП 2023 ЕООД", 
        activity: "Търговия на дребно", 
        vat: "Регистрация по ЗДДС",
        period: "2024 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=207307908"
    },
    { 
        name: "МИТОВ МАКС ЕООД", 
        activity: "Инвестиции в строителството", 
        vat: "Регистрация по ЗДДС",
        period: "2024 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=207721841"
    },
    { 
        name: "ПРОПЪРТИ ВЕНЧЪРС ЕООД", 
        activity: "Консултантски услуги", 
        vat: "Регистрация по ЗДДС",
        period: "2023 - 09.2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=175353191"
    },
    { 
        name: "АРС ВИВЕНДИ МК ЕООД", 
        activity: "Преводаческа дейност", 
        vat: "",
        period: "2020 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=202046055"
    },
    { 
        name: "ВЕРИНА ЕМ ЕООД", 
        activity: "Ремонт и поддръжка на мебели", 
        notes: "",
        vat: "",
        period: "2020 - 2026",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=203172516"
    },
    { 
        name: "НАТ – СТРОЙ 92 ЕООД", 
        activity: "Търговия на дребно", 
        vat: "",
        period: "2024 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=207346843"
    },
    { 
        name: "ЗЕЛЕНОТО КУЧЕ ЕООД", 
        activity: "Търговия на дребно", 
        vat: "",
        period: "2022 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=203974085"
    },
    { 
        name: "ЕРФУРИ И ЕТИ ООД", 
        activity: "Търговия на дребно", 
        vat: "",
        period: "2020 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=200732059"
    },
    { 
        name: "ДЕЙС-ОПТИК – ДАНИЕЛА ПАНЕКОВА ЕТ", 
        activity: "Търговия на дребно", 
        vat: "",
        period: "2023 - май 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=204672862"
    },
    { 
        name: "ЕВРООДИТ И ПАРТНЬОРИ ЕООД", 
        activity: "Консултантски услуги", 
        vat: "",
        period: "2023 - 09.2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=201878558"
    },
    { 
        name: "ФОНДАЦИЯ ЕВРОКОМПАС", 
        activity: "Консултантски услуги", 
        vat: "",
        period: "2023 - 09.2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=176978112"
    },
    { 
        name: "ФОНДАЦИЯ ЕВРОИНТЕГРА", 
        activity: "Организация на форуми и срещи, Членски внос", 
        vat: "",
        period: "2023 - 09.2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=176914960"
    },
    { 
        name: "БЪЛГАРО-КИТАЙСКА ТЪРГОВСКО-ПРОМИШЛЕНА КАМАРА", 
        activity: "Търговско-промишлена камара", 
        vat: "",
        period: "2023 - 09.2025",
        link: "https://portal.registryagency.bg/CR/Reports/ActiveConditionTabResult?uic=208107860"
    },
    { 
        name: "БЪЛГАРСКА ХЪНТИНГТЪН АСОЦИАЦИЯ", 
        activity: "Делегирана държавна дейност", 
        vat: "",
        period: "07.2025 - 2025",
        link: "https://portal.registryagency.bg/CR/en/Reports/ActiveConditionTabResult?uic=176658639"
    },
    { 
        name: "ЕДНОКРАТНА УПОТРЕБА ЕООД", 
        activity: "Производство", 
        notes: "Месечно обслужване - продажби и банкови транзакции отдел София",
        vat: "",
        period: "2020 - 2026",
        link: ""
    }
];